// extracted by mini-css-extract-plugin
export var documentation = "_kr-1";
export var menu = "_kr-0";